/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const useStyles = makeStyles((theme) => ({
  divMain: {
    // width: "95%",
    // height: "100px",
    // padding: theme.spacing(1),
    // backgroundColor: "red",
    // cursor: "pointer",
    // "&:hover": {
    //   background: "#3B3D40",
    //   boxShadow: "0 0px 16px 0 rgba(90, 90, 90, 0.2)",
    // },
    marginBottom: 20,
  },
  photo: {
    width: 40,
    height: 40,
    aspectRatio: 1,
    objectFit: "cover",
    borderRadius: "50%",
  },
  typoName: {
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1.36,
    textAlign: "left",
    color: "#fff",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    maxWidth: "100%",
  },
  typoRole: {
    fontFamily: "Roboto",
    fontSize: 12,
    lineHeight: 1.33,
    textAlign: "left",
    color: "#acacac",
    marginBottom: 3,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    maxWidth: "100%",
  },
  typoHour: {
    fontFamily: "Roboto",
    fontSize: 20,
    lineHeight: 1.3,
    textAlign: "left",
    color: "#fff",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    maxWidth: "100%",
  },
}));

export default function InOutComponent(props) {
  const classes = useStyles();

  // const setPhotoProfile = (urlPhoto) => {
  //   props.setUserData({
  //     ...props.userData,
  //     foto: urlPhoto,
  //     fotoCache: urlPhoto,
  //   });
  //   props.setOpendialogSearch(!props.openDialogSearch);
  // };

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      className={classes.divMain}
      // onClick={() =>
      //   props.setOpenDialogSearchEmployee(!props.openDialogSearchEmployee)
      // }
    >
      <Grid
        item
        xs={2}
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <img src={props.urlPhoto} className={classes.photo} alt="photo" />
      </Grid>

      <Grid item xs={6} container direction="column">
        <Typography className={classes.typoName}>{props.name}</Typography>
        <Typography className={classes.typoRole}>{props.role}</Typography>
      </Grid>

      <Grid
        item
        xs={1}
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <FontAwesomeIcon
          icon={faArrowRight}
          style={{
            width: 16,
            height: 16,
            color: "#989898",
          }}
        />
      </Grid>

      <Grid
        item
        xs={3}
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Typography className={classes.typoHour}>{props.hour}</Typography>
      </Grid>
    </Grid>
  );
}
